import { jwtDecode } from 'jwt-decode'

import { vars } from '@app/config'
import { Jwt } from '@app/models'
import { setCookie } from '@app/services'

import { getActiveAuthTokenFromCookies } from './getActiveAuthTokenFromCookies'

const getTokenRoles = (accessToken: string) =>
  (jwtDecode(accessToken) as Jwt)?.roles || []

export const setRolesCookieFromToken = (
  accessToken: string | null | undefined,
  hours = 48
) => {
  if (!accessToken) {
    return
  }

  try {
    setCookie(vars.roles, encodeURIComponent(getTokenRoles(accessToken)), hours)
  } catch {
    // Ignore malformed tokens and continue with runtime user data.
  }
}

export const setRolesCookieFromActiveToken = (hours = 48) => {
  setRolesCookieFromToken(getActiveAuthTokenFromCookies(), hours)
}